import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-report-table-row-parameters-period',
  templateUrl: './report-table-row-parameters-period.component.html',
  styleUrls: ['./report-table-row-parameters-period.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportTableRowParametersPeriodComponent {
  @Input() public parameter: Array<string> | null | undefined;
}
